import { BROWSER_STORAGE_KEYS } from './constants'

export function getAuthInfo() {
  return JSON.parse(localStorage.getItem(BROWSER_STORAGE_KEYS.auth))
}

export function saveAuthInfo(data) {
  localStorage.setItem(BROWSER_STORAGE_KEYS.auth, JSON.stringify(data))
}

export function deleteAuthInfo() {
  localStorage.removeItem(BROWSER_STORAGE_KEYS.auth)
}

export function getValueOrNull(value) {
  if (value === undefined || value === '') return null
  return value
}

export function getPluralOrSingular(word, count, endsWithVowel = false) {
  return `${
    count !== 1
      ? `${count} ${word}${endsWithVowel ? 'es' : 's'}`
      : `${count} ${word}`
  }`
}

export function formatAttachment(obj) {
  const fileName = obj.url.split('/').pop()
  const file = new File([], fileName)

  obj.file = file
  return obj
}
